import { View, Pressable, StyleSheet } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';

import { Text, WebCard, spacing } from '@pletly/ui';
import { useMyOrganisationsQuery } from './__generated__/myOrganisations.generated';
import { withTranslation } from '../../../../locales/hoc';

export const MyOrganisations = withTranslation(() => {
	const { navigate } = useNavigation();
	const { t } = useTranslation();
	const { data, loading } = useMyOrganisationsQuery();
	if (loading) {
		return null;
	}

	return (
		<View>
			<Text category="h2">{t('my-organisations')}</Text>

			{data?.currentUser.organisationMember?.map(({ organisation, role }) => (
				<Pressable
					key={organisation.uuid}
					onPress={() => navigate('Home', { uuid: organisation.uuid })}
				>
					<WebCard style={styles.item}>
						<Text category="h3">{organisation.name}</Text>
						<Text category="h6">{`${t('my-role')} ${role}`}</Text>
					</WebCard>
				</Pressable>
			))}
		</View>
	);
});

const styles = StyleSheet.create({
	item: { marginTop: spacing(3), gap: spacing(2) },
});
